import type { ButtonProps } from '@mui/material';
import { BookIcon } from '@src/shared/ui/icons';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from './IconButton';

const BalanceIconButton = forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => {
    const { t } = useTranslation();
    const tooltipTitle = t('common.balance_history', 'Balance history');

    return (
      <IconButton ref={ref} {...props} tooltipTitle={tooltipTitle}>
        <BookIcon color="inherit" />
      </IconButton>
    );
  },
);

BalanceIconButton.displayName = 'BalanceIconButton';
export default BalanceIconButton;
